var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M363.3,70h53.3v26.7H390v26.7h-53.3v80h-53.3v-26.7H310v-80h53.3V70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,70v186.7h186.7V70H70z M230,230H96.7V96.7H230V230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,70v186.7H630V70H443.3z M603.3,230H470V96.7h133.3L603.3,230L603.3,230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,123.3h80v80h-80V123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.7,123.3h80v80h-80V123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.3,150H390v26.7h-26.7V150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,176.7h26.7v106.7H390V230h-26.7v26.7h-26.7v-53.3H390V176.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,230H310v26.7h26.7v26.7H310v53.3h26.7V310h26.7v-26.7H390v80h-53.3V390H310v-26.7h-26.7V310H230v-26.7h53.3V230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,283.3h53.3V310h-53.3V283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,283.3H470V310h-26.7v26.7h-26.7V283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.7,283.3h26.7V310h-26.7L496.7,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,310h53.3v26.7H150v26.7h-26.7V390H96.7v-53.3H70V310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,310H230v26.7h-26.7v26.7H230V390h-53.3V310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.3,310H550v26.7h26.7v80H550V390h-53.3v26.7H470v-53.3h53.3V310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,336.7h26.7v26.7H230V336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.3,336.7H630v26.7h-26.7V336.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.7,363.3h26.7v53.3H230V390h26.7V363.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,363.3h26.7V390H390V363.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,390h26.7v26.7H70V390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,390H150v26.7h-26.7V390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,390H390v26.7h-26.7V470h-26.7v53.3H310V470h-26.7v-53.3H310v26.7h26.7V390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,390h26.7v26.7h-26.7V390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.3,390H630v26.7h-26.7V390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,416.7h26.7V470H390V416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.3,416.7H550V470h-26.7V416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.7,416.7h26.7v26.7h-26.7V416.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470,443.3h26.7V470h26.7v53.3h80V550H496.7v53.3H470V550h-26.7v26.7h-26.7v26.7h26.7V630H310v-26.7h80V550h26.7v-80H470 L470,443.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,443.3V630h186.7V443.3L70,443.3z M230,603.3H96.7V470H230V603.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.3,470H390v26.7h-26.7V470z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550,470h53.3v26.7H550V470z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,496.7h80v80h-80V496.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.3,496.7H630v26.7h-26.7V496.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.3,523.3H310V550h26.7v26.7h-53.3V523.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,523.3H390V550h-53.3V523.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550,576.7h26.7v26.7H550V576.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.3,576.7H630v26.7h-26.7V576.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.7,603.3h26.7V630h-26.7L496.7,603.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.654912a07e3b8d001b48e6e1d21975ff.svg";
export { ForwardRef as ReactComponent };